import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import detail from './modules/detail'
import myOrder from './modules/myOrder'
import socket from './modules/socket'
import kiosk from './modules/kiosk'
import globalStore from './modules/global'
import VuexPersistence from 'vuex-persist'
import takeMeal from '@/store/modules/takeMeal'
import storeModule from './modules/store'
import { bootGate } from '../utils/gate'
import { createUserPersistenceOptions } from '../utils/userPersistence'

const vxLocalStorage = new VuexPersistence(
	createUserPersistenceOptions(window.localStorage),
)
const vxSessionStorage = new VuexPersistence({
	storage: window.sessionStorage,
	modules: ['kiosk'],
})
const openGateAfterRestore = store => {
	// 若 vuex-persist 使用了「非同步儲存」，會提供 store.restored（Promise）
	const p = store && store.restored
	if (p && typeof p.then === 'function') {
		p.then(
			() => bootGate.open(), // 還原成功 → 開門
			err => {
				// 還原失敗 → 可視策略中止或仍開門
				// 嚴格策略：中止，讓所有 API 立即被拒絕（攔截器可辨識錯誤碼）
				// bootGate.abort(err || new Error('RESTORE_FAILED'))
				// 寬鬆策略：仍放行，但頁面自行處理降級
				bootGate.open()
			},
		)
	} else {
		// 同步儲存（localStorage / sessionStorage）→ 當下已完成還原
		// 放到 microtask（下一輪）開門，保證前面兩個插件的同步 replaceState 已跑完
		Promise.resolve().then(() => bootGate.open())
	}
}

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		user,
		detail,
		myOrder,
		socket,
		takeMeal,
		kiosk,
		store: storeModule,
	},
	getters,
	...globalStore,
	plugins: [
		vxLocalStorage.plugin,
		vxSessionStorage.plugin,
		openGateAfterRestore,
	],
})

export default store
